import { ControllerInterface } from "csi/action/Controller";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import declare from "dojo/_base/declare";
import _ from "lodash";
import ProductSelectProductHierarchyForm from "./ProductSelectProductHierarchyForm";

const ProductHierarchyFoodNewCopyParams = declare(null, {
	/**
	 * @override
	 * Build create food request
	 */
	toWriterRequest() {
		const controller = this as unknown as ControllerInterface;

		const call = controller.inherited<CallMethod>(arguments);

		const fd = controller.m_formData;
		const autoCreateSKUValue = fd.getFieldValue("AutoCreateSKU", true);
		const copyQuantityLabel = fd.getFieldValue("CopyCount", true) ? "CopyCount" : "NumToCreate";
		const copySKUValue = fd.getFieldValue("CopySKUs", true);
		const foodURL = controller.m_urlContext !== "centric:" ? controller.m_urlContext : controller.m_nodeSource.$URL;
		const form = fd.m_source?.popupView as typeof ProductSelectProductHierarchyForm.prototype;
		const leafFolderLabel = form._labelLeafFolder;
		const leafFolderUrl = leafFolderLabel ? fd.getFieldValue(leafFolderLabel, true) : controller.getCache().getNode(controller.m_urlParent).__Parent__;

		// Need to add Node Name to request to avoid ChangeNode call for Node Name as it won't work for Mass Create Product
		// C8FB-1129: Need to add Node Name to request to avoid ChangeNode call for Node Name as it won't work for Mass Create Product
		call.addParameter("Node Name", xml.ATTR_STRING, fd.getFieldValue("Node Name", true));
		call.addParameter("ProductSubtype", xml.ATTR_REF, fd.getFieldValue("Subtype", true));
		call.addParameter("ProductHierarchyFolder", xml.ATTR_REF, leafFolderUrl);

		if (controller.m_action.m_request.m_operation == "CopyFood") {
			call.addParameter("CopyCount", xml.ATTR_INTEGER, fd.getFieldValue(copyQuantityLabel, true));
			call.addParameter("isNewFrom", xml.ATTR_BOOLEAN, copyQuantityLabel === "NumToCreate");
		} else {
			call.addParameter("NumToCreate", xml.ATTR_INTEGER, fd.getFieldValue("NumToCreate", true));
		}

		if (foodURL) {
			call.addParameter("Food", xml.ATTR_REF, foodURL);
		}
		if (autoCreateSKUValue) {
			call.addParameter("AutoCreateSKU", xml.ATTR_BOOLEAN, autoCreateSKUValue);
		}
		if (copySKUValue) {
			call.addParameter("CopySKU", xml.ATTR_REFLIST, copySKUValue);
		}

		const projectFieldVal = fd.getFieldById("Project")?.getValue();
		if (projectFieldVal) {
			call.addParameter("Project", xml.ATTR_REF, projectFieldVal);
		}

		_.forEach(fd.getFields(), (field) => {
			const fieldId = field.idParameter || field.m_id;
			if (fieldId && !field.m_bUsed) {
				call.addGeneralizedParameter(fieldId, field.getType(), field.getValue());
				field.m_bUsed = true;
			}
		});

		return call;
	},
});

export = ProductHierarchyFoodNewCopyParams;
